/* import __COLOCATED_TEMPLATE__ from './reviewable-created-by.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
